import { RootState } from "../..";

export const selectPlanState = (state: RootState) => state.main.user.plan;

export const selectAvailablePlans = (state: RootState) => state.main.user.plan.availablePlans;

export const selectCurrency = (state: RootState) => state.main.user.plan.currency
